import * as Cookies from "js-cookie";
import { sendRequest } from "../helpers/ajax";
import IAuthenticateUserWithTokenRequest from "../types/IAuthenticateUserWithTokenRequest";
import IAuthenticationResponse from "../types/IAuthenticationResponse";
import IResponse from "../types/IResponse";
import IUserSession from "../types/IUserSession";
import * as Constants from "./constants";

let appSingleton: Application;

class Application {

    public userSession: IUserSession | null;
    public webServiceBaseURL: string;
    public webServiceBaseDomain: string;

    constructor() {
        this.setWebServiceUrls();
    }

    public async logInWithToken(token: string): Promise<boolean> {
        if (token) {

            // Attempt to login based on a previously issued auth token
            const request: IAuthenticateUserWithTokenRequest = { token };
            const response = await sendRequest<IResponse<IAuthenticationResponse>>("/api/authentication/authenticateuserwithtoken", "POST", request);

            if (response && response.success && response.payload.success) {
                this.logInUser(response.payload.userSession);
                return true;
            }
        }

        return false;
    }

    public logInUser(userSession: IUserSession) {
        this.userSession = userSession;
        Cookies.set(Constants.COOKIE_AUTHTOKEN, userSession.authenticationToken);
    }

    public logOutUser() {
        this.userSession = null;
        Cookies.remove(Constants.COOKIE_AUTHTOKEN)
    }

    public userHasPermission(permissionID: number): boolean {
        if (this.userSession && this.userSession.permissions.indexOf(permissionID) >= 0){
            return true;
        }
        return false;
    }

    private setWebServiceUrls(): void {
        switch (window.location.host.toLowerCase()) {
            case "localhost:3001":
                this.webServiceBaseURL = "http://localhost:20526";
                this.webServiceBaseDomain = "localhost";
                break;
            case "apiportal.cginotifydev.com":
                this.webServiceBaseURL = "https://apiportalservice.cginotifydev.com";
                this.webServiceBaseDomain = "cginotifydev.com";
                break;
            case "apiportal.cginotifyqa.com":
                this.webServiceBaseURL = "https://apiportalservice.cginotifyqa.com";
                this.webServiceBaseDomain = "cginotifyqa.com";
                break;
            case "apiportal.cginotify.com":
                this.webServiceBaseURL = "https://apiportalservice.cginotify.com";
                this.webServiceBaseDomain = "cginotify.com";
                break;
            case "apiportal.cginotify.net":
                this.webServiceBaseURL = "https://apiportalservice.cginotify.net";
                this.webServiceBaseDomain = "cginotify.net";
                break;
             case "apiportal.cginotify.co.uk":
                this.webServiceBaseURL = "https://apiportalservice.cginotify.co.uk";
                this.webServiceBaseDomain = "cginotify.co.uk";
                break;
            }
    }
}

function app(): Application {
    if (!appSingleton) {
        appSingleton = new Application();
    }

    return appSingleton;
}

export default app;



// WEBPACK FOOTER //
// ./src/core/application.ts